import { render, staticRenderFns } from "./ParallaxHorizontal.vue?vue&type=template&id=cb150616&scoped=true&"
import script from "./ParallaxHorizontal.vue?vue&type=script&lang=js&"
export * from "./ParallaxHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxHorizontal.vue?vue&type=style&index=0&id=cb150616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb150616",
  null
  
)

export default component.exports